import * as React from 'react';
import { Section } from '../../uiComponents/layout/Section';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import DraftHelper from '../../infrastructure/DraftHelper';
import RichTextEditor from '../../uiComponents/input/RichTextEditor';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { VejledningAfsnit } from '../../models/VejledningAfsnit';

export interface VejledningAfsnitPresenterProps {
    afsnit: VejledningAfsnit;
    index: number;
}

export default class VejledningAfsnitPresenter extends React.Component<VejledningAfsnitPresenterProps, any> {
    getEditorState = () => {
        return DraftHelper.getContentAsEditorState(this.props.afsnit.editorStateJson);
    }

    render() {
        return (
            <SectionGroup id={'afsnit_' + this.props.index} header={this.props.afsnit.overskrift}>
                <Section>
                    <Row>
                        <Col md={6} mdOffset={3}>
                            <RichTextEditor readOnly={true} editorState={this.getEditorState()} />
                        </Col>
                    </Row>
                </Section>
            </SectionGroup>
            
        );
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Vejledning/VejledningAfsnitPresenter.tsx